export default __webpack_public_path__ + "static/media/v3Our-services-Hotels-photo.05982e1f.jpg";